export { IconsCalendar1 } from "./IconsCalendar1";
